var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('Auth')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authHeader"},[_c('h1',[_vm._v("\n      Basic Bible Studies from the Foundry\n    ")])])}]

export { render, staticRenderFns }